

import useReactiveZone from "reactive-zone";
import FieldModel from "../../models/FieldModel.js";
import FieldOptionModel from "../../models/FieldOptionModel.js";
import Utils from "../../utils/Common.util.js";
import TaiBaseWidget from "../base.widget.js";


import singleChoiceTemplate from './SingleChoice.template.html';


class SingleChoiceWidget extends TaiBaseWidget {


    valueSelected = ''

    onInit() {

    }

    template() {
        return singleChoiceTemplate;
    }

    onZoneInit() {
        const { updateZone, injectMethodToZone, injectPropToZone } = useReactiveZone(this);

        injectMethodToZone({
            onChange: this.onChanges.bind(this)
        })

        this.props = injectPropToZone({
            options: this.fieldModel.fieldOptions,
            valueSelected: ''
        })

        injectMethodToZone({
            onChange: this.onChanges.bind(this)
        })
    }

    onRendered() {


    }

    clearValue() {
        const { code } = this.fieldModel;
        this.inputControls.forEach(item => item.checked = false)
    }

    getValue() {
        return this.fieldModel.userResponse;
    }


    /**
     * 
     * @param {HTMLElement} input 
     */
    loadedInput(input) {
        console.log('loaded', input);
    }

    /**
     * 
     * @param {MouseEvent} ev 
     * @param {FieldOptionModel} self 
     */
    onChanges(ev, item) {
        console.log('selected', item)
        // this.props.valueSelected = value;
    }
}

export default SingleChoiceWidget;